import { HERO_SCENE } from '../content/visuals';

const STATS = [
  ['Points', '12.4 M'],
  ['Frame rate', '8.7 Hz'],
  ['Depth range', '0.3 – 25.0 m'],
  ['Position', '12.36, 4.21, 1.02'],
  ['Status', 'Scanning…'],
];

export default function HeroScene() {
  return (
    <figure className="bv-hero-visual">
      <img
        src={HERO_SCENE.src}
        srcSet={HERO_SCENE.srcSet}
        sizes={HERO_SCENE.sizes}
        alt={HERO_SCENE.alt}
        width={HERO_SCENE.width}
        height={HERO_SCENE.height}
        fetchPriority="high"
      />

      <div className="bv-hud bv-hud-live">
        <p className="bv-hud-title">
          <i />
          Live reconstruction
        </p>
        <dl>
          {STATS.map(([label, value]) => (
            <div key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <svg className="bv-measure-lines" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
        <line x1="28" y1="18" x2="28" y2="62" />
        <line x1="28" y1="62" x2="78" y2="78" />
        <line x1="78" y1="38" x2="78" y2="78" />
      </svg>
      <span className="bv-measure bv-measure-h">2.84 m</span>
      <span className="bv-measure bv-measure-w">6.32 m</span>
      <span className="bv-measure bv-measure-d">4.18 m</span>

      <div className="bv-hud bv-hud-map" aria-hidden="true">
        <p className="bv-hud-title">Top view</p>
        <svg viewBox="0 0 120 88" className="bv-topview">
          <rect x="8" y="10" width="104" height="68" rx="3" fill="none" stroke="rgba(255,255,255,0.22)" />
          <rect x="18" y="20" width="38" height="22" fill="rgba(255,255,255,0.08)" />
          <rect x="64" y="20" width="36" height="48" fill="rgba(255,255,255,0.06)" />
          <polygon points="24,72 40,58 32,72" fill="#c8f04a" />
        </svg>
      </div>

      <figcaption className="bv-hero-tagline">Real environments. Real intelligence.</figcaption>
    </figure>
  );
}
